//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions} from "vuex";
import LabeledControlLayout from "../../../../../MultiSiteClient/components/shared/labeled-control-layout";

export default {
  name: "change-password-card",
  components: {LabeledControlLayout},
  props: {
    userId: 0,
    userName: '',
    section: {
      type: Object,
      required: true,
    }
  },
  data: (vm) => ({
    changePasswordForm: {
      data: {
        newPassword: '',
        confirmPassword: '',
      },
      rules: [(v) => !!v || 'Required'],
      newPasswordRules: [
        (v) => !!v || 'Required',
      ],
      confirmPasswordRules: [
        (v) => !!v || 'Required',
        (v) =>
            (!!v && v === vm.changePasswordForm.data.newPassword) ||
            'Passwords must match',
      ],
    },

  }),
  computed: {
    backgrounColor(){
      return {
        backgroundColor: this.section.primary_color.fieldValue.value
      }
    },
    fontColor(){
      return {
        color: this.section.primary_color.fieldValue.value
      }
    }
  },
  methods: {
    ...mapActions('common/userProfile', [
      'changePassword',
    ]),
    async save() {
      if (
          this.$refs.changePasswordForm.validate() &&
          this.changePasswordForm.data.newPassword
      ) {
        this.changePasswordForm.data.userId = this.userId
        const response = await this.$axios.$post('/User/must-change-password', this.changePasswordForm.data)
        if (
            response &&
            response.apiMessages.hasErrors &&
            response.apiMessages.validationErrors
        ) {
          this.$toast.error(response.apiMessages.validationErrors.error)
        } else if (response) {
          this.$toast.success('Password successfully changed!')
          this.$emit('passwordChanged', {
            username: this.userName,
            password: this.changePasswordForm.data.newPassword,
          })
        }
      }
    },
  }
}
